import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import Menu from "~/components/menu/Menu";
import CommentsAttachments from "../../../components/Processes/conversations/CommentsAttachments";

import {
  downloadFileHandler,
  getDocumentLabel,
  formatFileSize,
} from "../../../utils/fileUtils";

const CommentMessage = ({
  messageInfo,
  deletedAt,
  formatDate,
  setDeleteModal,
  setSelectedMessage,
  conversation,
  relatedType = "",
}) => {
  const { id: userId, role: userRole } = useSelector((state) => state.login);
  const { id } = useParams();

  const getMessageHeader = () => {
    return (
      <>
        Comment added to the{" "}
        <Link
          to={`/process/${id}/milestones?milestoneId=${messageInfo?.taskData?.milestone}`}
          className="conversation_link"
        >
          {messageInfo?.taskData?.name}
        </Link>{" "}
        under the {messageInfo?.taskData?.milestoneData?.name} by{" "}
        {messageInfo?.userData?.first_name} {messageInfo?.userData?.last_name} (
        {role[messageInfo?.userData?.role]})
      </>
    );
  };

  const menuItems = [
    {
      label: "Delete Message",
      icon: "pi pi-trash",
      command: () => {
        setDeleteModal(true);
        setSelectedMessage(conversation);
      },
    },
  ];
  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "LSP",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "LSP Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  return (
    <div className="message-container">
      <Avatar icon={"pi pi-comment"} shape="square" className="task_comment" />
      <div className="message-content">
        <div className="meta-info">
          <p className="user-name">{getMessageHeader()} </p>
          <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
          {(userId === messageInfo?.created_by ||
            ["GXM_ADMIN"].includes(userRole)) &&
            !deletedAt && (
              <div className="menu-container">
                <Menu menuItems={menuItems} />
              </div>
            )}
        </div>
        {messageInfo?.content && !deletedAt && (
          <p className="message">"{messageInfo?.content}"</p>
        )}
        {deletedAt && (
          <p className="message deleted-msg">
            Message removed by{" "}
            {`${messageInfo?.updatedBy?.first_name} ${messageInfo?.updatedBy?.last_name} (${role[messageInfo?.updatedBy?.role]}).`}
          </p>
        )}
        {messageInfo?.attachmentData.length > 0 &&
          !deletedAt &&
          messageInfo?.attachmentData.map((file, index) => {
            return (
              <CommentsAttachments
                key={index}
                file={{
                  ...file,
                  createdByData: messageInfo?.userData,
                  createdAt: messageInfo?.updatedAt,
                }}
                icon="pi-download"
                progressBar={false}
                fileHandler={() => downloadFileHandler(file)}
                label={getDocumentLabel(file?.name)}
                size={formatFileSize(file?.size)}
                relatedType={relatedType}
              />
            );
          })}
      </div>
    </div>
  );
};

CommentMessage.proptypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
  status: PropTypes.string,
};

export default CommentMessage;
